import { render, staticRenderFns } from "./ExecutiveChatAssistant.vue?vue&type=template&id=2351f35b&scoped=true&"
import script from "./ExecutiveChatAssistant.vue?vue&type=script&lang=js&"
export * from "./ExecutiveChatAssistant.vue?vue&type=script&lang=js&"
import style0 from "./ExecutiveChatAssistant.vue?vue&type=style&index=0&id=2351f35b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2351f35b",
  null
  
)

export default component.exports